const COPY_FEEDBACK_TIMEOUT = 2000

// Общие кнопки копирования: текст лежит в data-copy-text. Обработчик один на
// документ — работают и кнопки из подгруженной разметки (окно брони в ЛК).
// Подпись после копирования — в data-copy-success (по умолчанию «Скопировано»),
// на кнопке в это время висит класс is-copied для стилей. Через 2 секунды
// подпись возвращается; data-copy-persist оставляет состояние «скопировано»
// навсегда (кнопка остаётся неактивной).
export function initCopyButtons() {
  document.addEventListener('click', async (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>(
      'button[data-copy-text]'
    )
    const text = button?.dataset.copyText
    if (!button || !text) return

    if (await copyText(text)) {
      // innerHTML, а не textContent: вместе с надписью вернётся иконка.
      const original = button.innerHTML
      button.textContent = button.dataset.copySuccess || 'Скопировано'
      button.disabled = true
      button.classList.add('is-copied')
      if (button.hasAttribute('data-copy-persist')) return

      setTimeout(() => {
        button.innerHTML = original
        button.disabled = false
        button.classList.remove('is-copied')
      }, COPY_FEEDBACK_TIMEOUT)
    } else {
      // eslint-disable-next-line no-alert -- фолбэк, когда копирование недоступно (http/старый браузер)
      window.prompt('Скопируйте текст вручную:', text)
    }
  })
}

// Clipboard API, а для старых Safari — временная textarea и execCommand.
async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()

    let copied = false
    try {
      copied = document.execCommand('copy')
    } catch {
      copied = false
    }
    textarea.remove()
    return copied
  }
}
